/**
 * Stats bar using server-side aggregate counts returned by the API.
 * Counts reflect the full dataset (respecting current filters), not just the current page.
 */
function PaymentSummaryBar({ statusCounts = {}, total }) {
    const { pending = 0, completed = 0, cancelled = 0 } = statusCounts;

    return (
        <div className="flex flex-wrap items-center gap-4 px-4 py-2 bg-surface rounded-lg border text-sm">
            <span className="text-content-3">
                Tổng cộng: <strong className="text-content-2">{total}</strong>
            </span>
            <span className="text-orange-600 border-l pl-4">
                Chờ duyệt: <strong>{pending}</strong>
            </span>
            <span className="text-green-600 border-l pl-4">
                Đã xử lý: <strong>{completed}</strong>
            </span>
            <span className="text-content-3 border-l pl-4">
                Đã huỷ: <strong>{cancelled}</strong>
            </span>
        </div>
    );
}

export default PaymentSummaryBar;
